import React, { useRef, useEffect } from 'react';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-date-fns';

const HousingToEmployeesRatio = ({ location }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.getContext('2d');
      if (ctx) {
        // Destroy existing chart if it exists
        if (chartInstance.current) {
          chartInstance.current.destroy();
        }

        // Create placeholder data based on CSV structure
        const chartData = {
          labels: ['2012', '2015', '2018', '2021', '2023'],
          datasets: [
            {
              label: 'Housing Units',
              data: [47300, 48500, 50000, 51500, 52182], // Placeholder data
              borderColor: 'rgba(59, 130, 246, 1)',
              backgroundColor: 'rgba(59, 130, 246, 0.1)',
              fill: true,
              tension: 0.1
            },
            {
              label: 'Employees',
              data: [52000, 54000, 56000, 58000, 60334], // Placeholder data
              borderColor: 'rgba(239, 68, 68, 1)',
              backgroundColor: 'rgba(239, 68, 68, 0.1)',
              fill: true,
              tension: 0.1
            }
          ]
        };

        const chartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          animation: false,
          plugins: {
            title: {
              display: true,
              text: `Jobs vs Housing Balance - ${location}`,
              font: { size: 16, weight: 'bold' }
            },
            legend: {
              position: 'top',
              labels: {
                usePointStyle: true,
                padding: 20
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Count'
              }
            },
            x: {
              title: {
                display: true,
                text: 'Year'
              }
            }
          }
        };

        chartInstance.current = new Chart(ctx, {
          type: 'line',
          data: chartData,
          options: chartOptions
        });

        // Prevent chart from resizing continuously
        if (chartInstance.current.resize) {
          chartInstance.current.resize = () => {};
        }
      }
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [location]);

  return (
    <div className="chart-container" style={{ height: '400px', width: '100%', position: 'relative' }}>
      <canvas ref={chartRef} style={{ height: '400px', width: '100%', display: 'block' }} />
    </div>
  );
};

export default HousingToEmployeesRatio;
